import { isMobile } from 'utils'
import { isCordova } from 'env.js'
import axios from 'axios'

import { API_URL } from '../api'

let lastTouchY = null

export const setDeviceToken = user => {
    if(window.FirebasePlugin && isCordova){
        const deviceType = window.device ? window.device.platform : ''

        window.FirebasePlugin.getToken(token => {
            axios.post(API_URL+'/user/setPushToken', { 
                user,
                token,
                deviceType
            }).catch(error => {
                console.log('TOKEN ERROR')
                console.log(error)
            })
        })
    }
}

export const handleTouchMove = (e, type) => {
    if(!isMobile() || !e){
        return
    }

    const element = e.currentTarget
    const distanceFromBottom = element.scrollHeight - (element.scrollTop + element.clientHeight)
    let direction = null

    if(type == 'start'){
        lastTouchY = e.touches[0].clientY
    }else{
        const newTouchY = e.touches[0].clientY
        direction = (lastTouchY - newTouchY) < 0 ? 'up' : 'down'

        if(direction == 'up' && element.scrollTop <= 0){
            e.preventDefault()
        }

        if(direction == 'down' && distanceFromBottom <= 0){
            e.preventDefault()
        }
        
        lastTouchY = e.touches[0].clientY
    }
}

export const updateKeyboardHeight = height => {
    return dispatch => {
        dispatch({
            type: 'KEYBOARD_HEIGHT_UPDATED',
            payload: height,
        });
    }
}


// WEBPACK FOOTER //
// ./src/state/actions/mobile-actions.jsx